import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { sizeOf } from "../../utils/propTypes";
import css from "./ButtonGroup.module.css";

export const ButtonGroupContext = React.createContext(null);

const ButtonGroup = React.forwardRef(
  (
    { orientation = "horizontal", size, variant, className, children, ...rest },
    ref,
  ) => (
    <ButtonGroupContext.Provider
      value={size || variant ? { size, variant } : null}
    >
      <div
        ref={ref}
        role="group"
        className={clsx(css.root, className)}
        data-orientation={orientation}
        {...rest}
      >
        {children}
      </div>
    </ButtonGroupContext.Provider>
  ),
);

ButtonGroup.displayName = "ButtonGroup";

ButtonGroup.propTypes = {
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  size: sizeOf("sm", "md", "lg"),
  variant: PropTypes.oneOf(["filled", "tonal", "outlined", "text", "elevated"]),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ButtonGroup;
